import { render, staticRenderFns } from "./MortgagesOrCharges.vue?vue&type=template&id=d4b4460a&"
import script from "./MortgagesOrCharges.vue?vue&type=script&lang=js&"
export * from "./MortgagesOrCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports